import React from "react";
import { AnalystSkeletonCard, AnalystSkeletonGrid } from "./Analysts.styles";

const AnalystsFeedSkeleton = () => (
  <AnalystSkeletonGrid aria-hidden="true">
    {Array.from({ length: 8 }, (_, index) => (
      <AnalystSkeletonCard key={index} />
    ))}
  </AnalystSkeletonGrid>
);

export default AnalystsFeedSkeleton;
